export default __webpack_public_path__ + "static/media/keyboard.6e994419.gif";